/* @kdd-custom — A1 recherche qui filtre la FAQ (page foire-aux-questions).
   Filtre les <details class="bf-faq__item"> des 6 sections bf-faq-blocs au
   fil de la frappe ; une section dont toutes les questions sont masquées
   disparaît avec son titre. Champ visible UNIQUEMENT sous
   [data-kdd-faq-actif] (posé ici) — sans JS, ancres et accordéons natifs
   fonctionnent tels quels. */
(function () {
  function initFaq() {
    var racine = document.querySelector('[data-kdd-faq]');
    if (!racine || racine.hasAttribute('data-kdd-faq-actif')) return;
    var champ = racine.querySelector('input[type="search"]');
    if (!champ) return;

    var items = Array.prototype.slice.call(document.querySelectorAll('.bf-faq__item'));
    if (!items.length) return;
    racine.setAttribute('data-kdd-faq-actif', '');

    /* Une entrée = son <details> + sa section englobante (pour masquer le
       rayon entier quand il est vide). */
    var sections = [];
    items.forEach(function (it) {
      var sec = it.closest('.shopify-section');
      if (sec && sections.indexOf(sec) === -1) sections.push(sec);
    });

    function normalise(s) {
      return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    function filtre() {
      var q = normalise(champ.value.trim());
      var actif = q.length >= 2;
      var total = 0;
      items.forEach(function (it) {
        var ok = !actif || normalise(it.textContent).indexOf(q) > -1;
        it.style.display = ok ? '' : 'none';
        if (actif && ok) it.open = true;
        if (!actif) it.open = false;
        if (ok) total++;
      });
      sections.forEach(function (sec) {
        var visibles = Array.prototype.some.call(
          sec.querySelectorAll('.bf-faq__item'),
          function (it) { return it.style.display !== 'none'; }
        );
        sec.style.display = visibles ? '' : 'none';
      });
      if (actif && total === 0) {
        racine.setAttribute('data-kdd-faq-vide', '');
      } else {
        racine.removeAttribute('data-kdd-faq-vide');
      }
      /* La diode de l'afficheur (F1) : allumée dès qu'on tape. */
      if (champ.value.length) {
        racine.setAttribute('data-kdd-faq-saisie', '');
      } else {
        racine.removeAttribute('data-kdd-faq-saisie');
      }
    }

    champ.addEventListener('input', filtre);

    /* La barre sticky prend le relais de l'index en cartes : elle ne
       s'affiche que quand l'index est sorti de l'écran. Sans
       IntersectionObserver (ou sans JS), elle reste visible en permanence. */
    var index = racine.querySelector('[data-kdd-faq-index]');
    if (index && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) racine.removeAttribute('data-kdd-rail-on');
          else racine.setAttribute('data-kdd-rail-on', '');
        });
      }, { rootMargin: '-70px 0px 0px 0px' });
      io.observe(index);
    } else {
      racine.setAttribute('data-kdd-rail-on', '');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
  document.addEventListener('shopify:section:load', initFaq);
})();
